
import { Button } from 'react-bootstrap';
import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import CustomToolTip from '../../CommonComponents/CustomToolTip';
import { setCloneTemplate } from '../../../store/CatalogSlice';
import { ArrowSvg } from '../Svgs/CatalogSvgs';

const BusConfigSlider = ({ allComponents, closeBusSlider, busSlider, newTemplate }) => {

    const CloneTemplate = useSelector((state: any) => state.catalog.CloneTemplate);
    const dispatch = useDispatch();
    const sliderSelect: any = busSlider;
    const navigator = 'Integrated'

    const [busOSData, setBusOSData] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [busOBCData, setBusOBCData] = useState({});
    const [expanded, setExpanded] = React.useState('');
    const [getIntegratedData, setIntegratedData] = useState<any[]>([]);
    const [isIntegratedData, setIsIntegratedData] = useState<any>({});
    const [isCountBtnDisabled, setIsCountBtnDisabled] = useState(false);
    const [selectedIntegratedId, setSelectedIntegratedId] = useState<string>('');
    const [selectedTemplateData, setSelectedTemplateData] = useState<any>({});

    const getOtherTemplateData = (key) => {
        const filterdData = allComponents.filter((comp: any) => comp["catalogue-type"] === key) || []
        setIntegratedData(filterdData)
        setSelectedIntegratedId(key === 'Bus OBC' ? busOBCData?.['name'] : busOSData?.['name'])
    }

    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : '');
        if (isExpanded) {
            getOtherTemplateData(panel);
        }
    };

    const handleCancel = () => {
        closeBusSlider()
        setSelectedTemplateData({})
        setSelectedIntegratedId('')
    }
    useEffect(() => {
        if ((selectedIntegratedId === sliderSelect?.['data']?.['name'])) {
            setTotalCount(sliderSelect.numUnits)
        } else if ((sliderSelect?.type === 'Solar Panel' || sliderSelect?.type === 'Payload SSD' || sliderSelect?.type === 'Temperature Sensor' || sliderSelect?.type === 'Heater' || sliderSelect?.type === 'Thruster')) {
            setTotalCount(1)
        } else {
            setTotalCount(0)
        }
    }, [selectedIntegratedId, sliderSelect?.type])

    useEffect(() => {
        if (sliderSelect?.type && Object.keys(sliderSelect.data)?.length > 0) {
            if (sliderSelect?.type === 'ADCS' || sliderSelect?.type === 'iADCS') {
                const d = sliderSelect.data;
                setExpanded('')
                setIsIntegratedData(d)
            } else if (sliderSelect?.type === 'Bus OBC' || sliderSelect?.type === 'Bus OS') {
                setBusOSData(CloneTemplate?.['Core']?.['Bus OS'] || {})
                setBusOBCData(CloneTemplate?.['Core']?.['Bus OBC'] || {})
            }
        }
    }, [sliderSelect?.type, CloneTemplate])


    const handleIntegratedCloneData = (data) => {
        if (navigator === 'Integrated' && (sliderSelect?.type === 'ADCS' || sliderSelect?.type === 'iADCS')) {
            const result = {
                'iADCS': data,
                'adcsType': navigator
            }
            setSelectedTemplateData(result)
        } else if (navigator === 'Integrated' && (sliderSelect?.type === 'IMU' || sliderSelect?.type === 'iIMU')) {
            const result = {
                'iIMU': data,
                'imuType': navigator
            }
            setSelectedTemplateData(result)
        }
    }

    const handleSubmitCloneTemplate = () => {
        if (sliderSelect.type === 'Solar Panel' || sliderSelect.type === 'Payload SSD' || sliderSelect.type === 'Temperature Sensor' || sliderSelect.type === 'Heater' || sliderSelect.type === 'Thruster') {
            const data = ({ ...selectedTemplateData, [sliderSelect.type + 'Count']: totalCount })
            dispatch(setCloneTemplate({ [sliderSelect.subSystem]: data }))
        } else {
            dispatch(setCloneTemplate({ [sliderSelect.subSystem]: selectedTemplateData }))
        }
        handleCancel()
    }


    // {/* ////...........................................................//// */}

    useEffect(() => {
        if (sliderSelect?.type !== 'Bus OBC' && sliderSelect?.type !== 'Bus OS') {
            let filterdData = allComponents.filter((comp: any) => comp["catalogue-type"] === sliderSelect?.type) || []
            setIntegratedData(filterdData)
            setSelectedIntegratedId((sliderSelect?.type === 'ADCS') ? isIntegratedData?.['name'] : sliderSelect?.['data']?.['name'])
        }
    }, [sliderSelect?.type, sliderSelect?.subSystem])

    return <div className="right-slider-box config-slider edge-cards">
        <div className="slider-header">
            <h4>{sliderSelect?.type}</h4>
        </div>

        {(!newTemplate) && <div className="slider-content flex-1">
            <span className="sm-title">{(sliderSelect?.type === 'ADCS' || sliderSelect?.type === 'IMU') ? 'Discrete' : ''}</span>
            {sliderSelect?.type !== 'ADCS' && sliderSelect?.type !== 'IMU' &&
                <div className="common-card-box active">
                    <div className="common-card-content">
                        <span className='fs-18 color-text'>
                            {sliderSelect?.data?.['name']?.length > 30 ? sliderSelect?.data?.['name'].slice(0, 30) + '...' : sliderSelect?.data?.['name']}
                        </span>
                        <div className="d-flex flex-wrap">
                            {sliderSelect?.type === 'Payload' && <>
                                <div className="stats-alpha w-45">
                                    <CustomToolTip title={`${sliderSelect?.data?.['component_specific_attributes']['payloadType']}`}>
                                        <strong>{sliderSelect?.data?.['component_specific_attributes']['payloadType']}</strong>
                                    </CustomToolTip>
                                    <span>Category</span>
                                </div>
                                {sliderSelect?.data?.['component_specific_attributes']['payloadSubType'] && <div className="stats-alpha w-45">
                                    <CustomToolTip title={`${sliderSelect?.data?.['component_specific_attributes']['payloadSubType']}`}>
                                        <strong>{sliderSelect?.data?.['component_specific_attributes']['payloadSubType']}</strong>
                                    </CustomToolTip>
                                    <span>Payload Type</span>
                                </div>}
                                {sliderSelect?.data?.['component_specific_attributes']['payloadDetails'] && <div className="stats-alpha w-45">
                                    <CustomToolTip title={`${sliderSelect?.data?.['component_specific_attributes']['payloadDetails']}`}>
                                        <strong>{sliderSelect?.data?.['component_specific_attributes']['payloadDetails']}</strong>
                                    </CustomToolTip>
                                    <span>Payload SubType</span>
                                </div>}

                                {sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'] &&
                                    Object.keys(sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'])?.length > 0 &&
                                    Object.keys(sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams']).map((k, i) => {
                                        return (
                                            <div key={k} className="stats-alpha w-45">                                             
                                                {k !== 'Frequency Bands' && <strong>
                                                    {k === 'GSD' ?
                                                        (sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'][k] + ' m') :
                                                        (k === 'Swath' ? (sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'][k] + ' km') :
                                                            sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'][k])}
                                                </strong>}                           
                                                {k === 'Frequency Bands' &&
                                                    <div className='d-flex flex-wrap flex-1'>
                                                        {sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'][k].map((band, index) =>
                                                            <div className='d-flex gap-1' key={index}>
                                                                <strong>{band}</strong>
                                                                {index !== (sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'][k].length - 1) && <strong className='pe-1 opacity-50'>|</strong>}
                                                            </div>
                                                        )}
                                                    </div>
                                                }                                               
                                                <span>{k}</span>
                                            </div>
                                        )
                                    })}
                                {sliderSelect?.data?.['component_specific_attributes']['additionalParams'] &&
                                    Object.keys(sliderSelect?.data?.['component_specific_attributes']['additionalParams'])?.length > 0 &&
                                    Object.keys(sliderSelect?.data?.['component_specific_attributes']['additionalParams']).map((k) => {
                                        return (
                                            <div key={k} className="stats-alpha w-45">
                                                <CustomToolTip title={`${sliderSelect?.data?.["product-cookie"]?.[k]}${k === 'Size' ? ' U' : ''}`} placement="top-start">
                                                <strong>{sliderSelect?.data?.['component_specific_attributes']['additionalParams'][k]}</strong>
                                                </CustomToolTip>
                                                <span>{k}</span>
                                            </div>
                                        )
                                    })}
                            </>}

                            {sliderSelect?.data && Object.keys(sliderSelect?.data?.["product-cookie"])?.length > 0 &&
                                Object.keys(sliderSelect?.data?.["product-cookie"]).filter(k => k !== 'friendly-name').map((k) => {
                                    return <div key={k} className="stats-alpha w-45">
                                        <CustomToolTip title={`${sliderSelect?.data?.["product-cookie"]?.[k]}${k === 'Size' ? ' U' : ''}`} placement="top-start">
                                            <strong>
                                                {sliderSelect?.data?.["product-cookie"]?.[k]}{k === 'Size' ? ' U' : ''}
                                            </strong>
                                        </CustomToolTip>

                                        <span>{k}</span>
                                    </div>
                                })}
                        </div>

                        {sliderSelect?.type === 'iADCS' &&
                            sliderSelect?.data && sliderSelect?.data["component_specific_attributes"] &&
                            sliderSelect?.data["component_specific_attributes"]["Components"] &&
                            sliderSelect?.data["component_specific_attributes"]["Components"].map((c) => {
                                return <div key={c?.['friendly-name']} className="common-card-box active sub-box">
                                    <div className="common-card-content">
                                        {c?.['numUnits'] !== '' && <div>{c?.['friendly-name']} ({c?.['numUnits']})</div>}
                                        <div className="d-flex flex-wrap">
                                            {Object.keys(c).filter(k => k !== 'friendly-name' &&
                                                k !== 'description' &&
                                                k !== 'numUnits').map((k, j) => {
                                                    return <div key={j} className="stats-alpha w-40">
                                                        <strong>{c[k]}</strong>
                                                        <span>{k}</span>
                                                    </div>
                                                })}
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div>
            }

            {(sliderSelect?.type === 'ADCS' || sliderSelect?.type === 'IMU') &&
                Object.keys(sliderSelect?.data).map((c) => {
                    return <div key={sliderSelect?.data[c]['atmos-data']?.['name']} className="common-card-box active">
                        <div className="common-card-content">
                            <div>
                                {sliderSelect?.data[c]['atmos-data']?.['name']}
                            </div>
                            <div className="d-flex flex-wrap">
                                {sliderSelect?.data[c]['atmos-data'] &&
                                    Object.keys(sliderSelect?.data[c]['atmos-data']?.["product-cookie"]).filter(
                                        k => k !== 'friendly-name').map((k) => {
                                            return <div key={k} className="stats-alpha w-45">
                                                <strong>{sliderSelect?.data[c]['atmos-data']?.["product-cookie"][k]}</strong>
                                                <span>{k}</span>
                                            </div>
                                        })}
                            </div>
                        </div>
                    </div>
                })}

            {(sliderSelect?.['data']?.['antenna'] && typeof sliderSelect?.['data']?.['antenna'] === 'object') &&
                <div className="common-card-box active">
                    <div className="common-card-content">
                        <div className='fs-18 opacity-75'>{sliderSelect?.data?.['antenna']['friendly-name']}</div>
                        <div className="d-flex flex-wrap">
                            {Object.keys(sliderSelect?.data?.['antenna']).map(k => {
                                if (k !== 'friendly-name') {
                                    return (
                                        <div className="stats-alpha w-45" key={k}>
                                            <strong>{sliderSelect?.data?.['antenna'][k]}</strong>
                                            <span>{k}</span>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    </div>
                </div>
            }
        </div>}

        {((!newTemplate) && (sliderSelect?.type === 'Edge Device' || sliderSelect?.type === 'Edge SSD' || sliderSelect?.type === 'Payload')) &&
            <div className="slider-content flex-1">
                <span className="sm-title">{(sliderSelect?.type === 'ADCS' || sliderSelect?.type === 'IMU') ? 'Discrete' : ''}</span>
                {sliderSelect?.type !== 'ADCS' && sliderSelect?.type !== 'IMU' &&
                    <div className="common-card-box active">
                        <div className="common-card-content">
                            <div>
                                {sliderSelect?.data?.['name']}
                            </div>
                            {<div className="d-flex flex-wrap">
                                {sliderSelect?.type === 'Payload' &&
                                    <Fragment>
                                        <div className="stats-alpha w-45">
                                            <strong>{sliderSelect?.data?.['component_specific_attributes']['payloadType']}</strong>
                                            <span>Category</span>
                                        </div>
                                        {sliderSelect?.data?.['component_specific_attributes']['payloadSubType'] && <div className="stats-alpha w-45">
                                            <strong>{sliderSelect?.data?.['component_specific_attributes']['payloadSubType']}</strong>
                                            <span>Payload Type</span>
                                        </div>}
                                        {sliderSelect?.data?.['component_specific_attributes']['payloadDetails'] && <div className="stats-alpha w-45">
                                            <strong>{sliderSelect?.data?.['component_specific_attributes']['payloadDetails']}</strong>
                                            <span>Payload SubType</span>
                                        </div>}

                                        {sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'] &&
                                            Object.keys(sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'])?.length > 0 &&
                                            Object.keys(sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams']).map((k) => {
                                                return (
                                                    <div key={k} className="stats-alpha w-45">
                                                        <strong>{k === 'GSD' ?
                                                            (sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'][k] + ' m') :
                                                            (k === 'Swath' ? (sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'][k] + ' km') :
                                                                sliderSelect?.data?.['component_specific_attributes']['typeSpecificParams'][k])}</strong>
                                                        <span>{k}</span>
                                                    </div>
                                                )
                                            })}
                                        {sliderSelect?.data?.['component_specific_attributes']['additionalParams'] &&
                                            Object.keys(sliderSelect?.data?.['component_specific_attributes']['additionalParams'])?.length > 0 &&
                                            Object.keys(sliderSelect?.data?.['component_specific_attributes']['additionalParams']).map((k) => {
                                                return (
                                                    <div key={k} className="stats-alpha w-45">
                                                        <strong>{sliderSelect?.data?.['component_specific_attributes']['additionalParams'][k]}</strong>
                                                        <span>{k}</span>
                                                    </div>
                                                )
                                            })
                                        }
                                        <div className="stats-alpha w-45 gap-2">
                                            <CustomToolTip title={`${sliderSelect?.data?.['component_specific_attributes']?.['interfaces']?.join(', ')}`}>
                                                <div className='d-flex align-items-center text-truncate'>
                                                    <strong>{sliderSelect?.data?.['component_specific_attributes']?.['interfaces']?.join(', ')}</strong>
                                                </div>
                                            </CustomToolTip>
                                            <span className='pt-1'>Interface</span>
                                        </div>
                                    </Fragment>
                                }

                                {sliderSelect?.data && Object.keys(sliderSelect?.data?.["product-cookie"])?.length > 0 &&
                                    Object.keys(sliderSelect?.data?.["product-cookie"]).filter(k => k !== 'friendly-name').map((k) => {
                                        return <div key={k} className="stats-alpha w-45">
                                            <strong>{sliderSelect?.data?.["product-cookie"][k]}{k === 'Size' ? ' U' : ''}</strong>
                                            <span>{k}</span>
                                        </div>
                                    })}
                            </div>}

                            {sliderSelect?.type === 'iADCS' &&
                                sliderSelect?.data && sliderSelect?.data["component_specific_attributes"] &&
                                sliderSelect?.data["component_specific_attributes"]["Components"] &&
                                sliderSelect?.data["component_specific_attributes"]["Components"].map((c) => {
                                    return <div key={c?.['friendly-name']} className="common-card-box active sub-box">
                                        <div className="common-card-content">
                                            {c?.['numUnits'] !== '' && <div>{c?.['friendly-name']} ({c?.['numUnits']})</div>}
                                            <div className="d-flex flex-wrap">
                                                {Object.keys(c).filter(k => k !== 'friendly-name' &&
                                                    k !== 'description' &&
                                                    k !== 'numUnits').map((k, j) => {
                                                        return <div key={j} className="stats-alpha w-45">
                                                            <strong>{c[k]}</strong>
                                                            <span>{k}</span>
                                                        </div>
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                }

                {(sliderSelect?.type === 'ADCS' || sliderSelect?.type === 'IMU') &&
                    Object.keys(sliderSelect?.data).map((c) => {
                        return <div key={sliderSelect?.data[c]['atmos-data']?.['name']} className="common-card-box active">
                            <div className="common-card-content">
                                <div>
                                    {sliderSelect?.data[c]['atmos-data']?.['name']}
                                </div>
                                <div className="d-flex flex-wrap">
                                    {sliderSelect?.data[c]['atmos-data'] &&
                                        Object.keys(sliderSelect?.data[c]['atmos-data']?.["product-cookie"]).filter(
                                            k => k !== 'friendly-name').map((k) => {
                                                return <div key={k} className="stats-alpha w-45">
                                                    <strong>{sliderSelect?.data[c]['atmos-data']?.["product-cookie"][k]}</strong>
                                                    <span>{k}</span>
                                                </div>
                                            })}
                                </div>
                            </div>
                        </div>
                    })}

                {(sliderSelect?.['data']?.['antenna'] && typeof sliderSelect?.['data']?.['antenna'] === 'object') &&
                    <div className="common-card-box active">
                        <div className="common-card-content">
                            <div className="d-flex flex-wrap">
                                {Object.keys(sliderSelect?.data?.['antenna']).map(k => (
                                    <div className="stats-alpha w-45" key={k}>
                                        <strong>{sliderSelect?.data?.['antenna'][k]}</strong>
                                        <span>{k === 'friendly-name' ? 'Name' : k}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                }
            </div>
        }


        {/* ///////////////////..............CLONE OR NEW TEMPLATE..................////////////////////// */}
        {(sliderSelect?.type === 'ADCS' || sliderSelect?.type === 'iADCS' || sliderSelect?.type === 'IMU' || sliderSelect?.type === 'iIMU') && <>
            <div className="slider-content flex-1 border">
                {getIntegratedData?.length > 0 && getIntegratedData.map((data: any) => (
                    <div key={data.name} className={selectedIntegratedId === data.name ? 'common-card-box active' : "common-card-box"}
                        onClick={() => {
                            setSelectedIntegratedId(data.name)
                            handleIntegratedCloneData(data)
                        }}>
                        <div className="common-card-content">
                            <div>
                                {data.name}
                            </div>
                            <div className="d-flex flex-wrap">
                                {Object.keys(data?.["product-cookie"]).filter(
                                    k => k !== 'friendly-name').map((k) => (
                                        <div key={k} className="stats-alpha w-45">
                                            <strong>{data["product-cookie"][k]}</strong>
                                            <span>{k}</span>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>}

        {!(sliderSelect?.type === 'Edge Device' || sliderSelect?.type === 'Edge SSD' || sliderSelect?.type === 'Payload') && (sliderSelect?.type !== 'IMU' && sliderSelect?.type !== 'iIMU' && sliderSelect?.type !== 'ADCS' && sliderSelect?.type !== 'iADCS') &&
            <div className="slider-content flex-1">
                {(sliderSelect?.type === 'Bus OBC') && ['Bus OBC', 'Bus OS'].map(key => (
                    <div className="common-card-box mb-3" style={{ borderRadius: '5px' }} key={key}>
                        <Accordion expanded={expanded === key} onChange={handleChange(key)}
                            sx={{
                                '&.transparent-mode': {
                                    backgroundColor: '#00000000',
                                    color: '#fff'
                                },
                                '&.MuiButtonBase-root': {
                                    backgroundColor: '#00000000',
                                    color: '#fff'
                                },
                                '&.MuiPaper-root': {
                                    backgroundColor: "#00000000",
                                    color: '#fff',
                                    padding: '0px !important'
                                }
                            }}>
                            <AccordionSummary
                                expandIcon={<span className="badge">
                                    <ArrowSvg />
                                </span>}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                sx={{
                                    '&.Mui-expanded': {
                                        borderBottom: '1px solid transparent',
                                        borderImage: 'linear-gradient(to right, #6E6E6E, transparent)',
                                        borderImageSlice: 1
                                    },
                                }}
                            >
                                <div className='d-flex w-100'>
                                    <div className="d-flex flex-column">
                                        <Typography sx={{ width: '100%', flexShrink: 0, fontWeight: 500, fontSize: '18px', lineHeight: '25px' }}>
                                            {key}
                                        </Typography>
                                        <Typography style={{ color: "#ddd" }} sx={{ fontSize: '14px', fontWeight: 300 }}>
                                            {key === 'Bus OBC' ? busOBCData?.['name'] : busOSData?.['name']}
                                        </Typography>
                                    </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    '&.MuiAccordionDetails-root': {
                                        paddingRight: '0px'
                                    }
                                }}
                            >
                                <div className="slider-content flex-1 p-0 pe-3"
                                    onClick={(e) => { e.stopPropagation() }}
                                >
                                    {(busOBCData?.['name'] && busOSData?.['name']) && <>
                                        <h4 style={{ display: 'flex', marginBottom: '10px' }}>Existing Component</h4>
                                        <div className={(((selectedIntegratedId === busOBCData?.['name']) && key === 'Bus OBC') ? busOBCData?.['name'] : busOSData?.['name']) ? 'common-card-box active' : "common-card-box"} style={{ width: '100%' }}
                                            onClick={() => {
                                                if (key === 'Bus OBC') {
                                                    setBusOBCData(busOBCData)
                                                    setSelectedIntegratedId(busOBCData['name'])
                                                    setSelectedTemplateData((prev) => ({ ...prev, [key]: busOBCData }))
                                                } else if (key === 'Bus OS') {
                                                    setBusOSData(busOSData)
                                                    setSelectedIntegratedId(busOSData['name'])
                                                    setSelectedTemplateData((prev) => ({ ...prev, [key]: busOSData }))
                                                }
                                                setExpanded('')
                                            }}>
                                            <div className="common-card-content">
                                                <div>
                                                    {(sliderSelect?.type === 'Bus OBC' && sliderSelect?.type === key) ? busOBCData['name'] : busOSData?.['name']}
                                                </div>
                                                <div className="d-flex flex-wrap">
                                                    {Object.keys((sliderSelect?.type === 'Bus OBC' && sliderSelect?.type === key) ? busOBCData?.["product-cookie"] : busOSData?.["product-cookie"]).filter(
                                                        k => k !== 'friendly-name').map((k) => (
                                                            <div key={k} className="stats-alpha w-40">
                                                                <strong>{(sliderSelect?.type === 'Bus OBC' && sliderSelect?.type === key) ? busOBCData?.["product-cookie"][k] : busOSData?.["product-cookie"][k]}</strong>
                                                                <span>{k}</span>
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <h4 style={{ display: 'flex', marginBottom: '10px' }}>{getIntegratedData && Object.keys(getIntegratedData).length === 0 && 'No '}Available Components </h4>
                                    {getIntegratedData.map((data: any) => (
                                        <div key={data?.name} className={selectedIntegratedId === data?.name ? 'd-none' : "common-card-box"} style={{ width: '100%' }}
                                            onClick={() => {
                                                if (key === 'Bus OBC') {
                                                    setBusOBCData(data)
                                                    setSelectedIntegratedId(data.name)
                                                    setSelectedTemplateData((prev) => ({ ...prev, [key]: data }))
                                                } else if (key === 'Bus OS') {
                                                    setBusOSData(data)
                                                    setSelectedIntegratedId(data.name)
                                                    setSelectedTemplateData((prev) => ({ ...prev, [key]: data }))
                                                }
                                                setExpanded('')
                                            }}>
                                            <div className="common-card-content">
                                                <div>
                                                    {data.name}
                                                </div>
                                                <div className="d-flex flex-wrap">
                                                    {Object.keys(data?.["product-cookie"]).filter(
                                                        k => k !== 'friendly-name').map((k) => (
                                                            <div key={k} className="stats-alpha w-40">
                                                                <strong>{data["product-cookie"][k]}</strong>
                                                                <span>{k}</span>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>))
                }
                {sliderSelect?.type !== 'Bus OBC' &&
                    <Fragment>
                        {getIntegratedData.map((data: any) => (
                            <div key={data?.name} className={selectedIntegratedId === data?.name ? 'common-card-box active' : "common-card-box"}
                                onClick={() => {
                                    setSelectedIntegratedId(data.name)
                                    setSelectedTemplateData({ [sliderSelect?.type]: data })
                                }}>
                                <div className="common-card-content">
                                    <div>
                                        {data.name}
                                    </div>
                                    <div className="d-flex flex-wrap">
                                        {Object.keys(data?.["product-cookie"]).filter(
                                            k => k !== 'friendly-name').map((k) => (
                                                <div key={k} className="stats-alpha w-45">
                                                    <strong>{data["product-cookie"][k]}</strong>
                                                    <span>{k}</span>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Fragment>
                }
            </div>
        }

        {((sliderSelect?.type === 'Solar Panel' || sliderSelect?.type === 'Payload SSD' || sliderSelect?.type === 'Temperature Sensor' || sliderSelect?.type === 'Heater' || sliderSelect?.type === 'Thruster')) &&
            <div className="slider-footer">
                <Button
                    variant="primary"
                    type="button"
                    disabled={totalCount === 1}
                    className="btn btn-primary counter-btn"
                    onClick={() => setTotalCount((prevState) => {
                        if (isCountBtnDisabled) {
                            setIsCountBtnDisabled(false)
                        }

                        if (prevState > 1 && totalCount > 1) {
                            return prevState - 1;
                        } else {
                            return 1;
                        }
                    })}
                >
                    <i className="fe fe-minus"></i>
                </Button>

                {totalCount}

                <Button
                    variant="primary"
                    type="button"
                    disabled={isCountBtnDisabled}
                    className="btn btn-primary counter-btn"
                    onClick={() => {
                        if (sliderSelect?.type !== 'Solar Panel') {
                            setTotalCount((prevState) => prevState + 1)
                        } else if (sliderSelect?.type === 'Solar Panel' && totalCount + 1 <= 5) {
                            setTotalCount((prevState) => prevState + 1)
                        } else if (sliderSelect?.type === 'Solar Panel' && totalCount === 5) {
                            setIsCountBtnDisabled(true)
                        }
                    }}
                >
                    <i className="fe fe-plus"></i>
                </Button>
            </div>
        }

        <div className="slider-footer">
            {!(sliderSelect?.type === 'Edge Device' || sliderSelect?.type === 'Edge SSD' || sliderSelect?.type === 'Payload') && <Button
                variant="primary"
                type="button"
                className="btn btn-outline-danger pt-1 pb-1 pe-7 ps-7 ms-5 fs-14"
                onClick={handleCancel}
            >
                Cancel
            </Button>}
            <Button
                variant="primary"
                type="button"
                className="btn btn-primary pt-1 pb-1 pe-7 ps-7 ms-5 fs-14"
                onClick={handleSubmitCloneTemplate}
            >
                Select
            </Button>
        </div>
    </div >
};
export default BusConfigSlider;
